var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"type":_vm.type,"size":"mini","underline":false},on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }